import { QUESTION_IDS } from 'consts';
import {
  BasicFormWizardContext,
  FormValues,
  SelectFieldOption,
  Question,
  School,
} from 'types';
import { getFieldValue } from 'utils/formValuesUtils';

export function shouldSync29To54(
  allQuestionsInForm: BasicFormWizardContext['allQuestionsInForm'],
  formValues: FormValues,
  question: Question,
  currentOptions: (SelectFieldOption | School)[]
): boolean {
  if (question.questionId !== QUESTION_IDS.CONCENTRATIONS) {
    return false;
  }

  const curatedQuestion = allQuestionsInForm?.[QUESTION_IDS.CURATED_QUESTION];
  if (!curatedQuestion) {
    return false;
  }

  const curatedQuestionValue = getFieldValue(formValues, curatedQuestion.name);
  if (!Array.isArray(curatedQuestionValue)) {
    return false;
  }

  const hasSameNumberOfOptions =
    currentOptions.length === curatedQuestionValue.length;
  const hasSameOptions = currentOptions.every((option) => {
    if (typeof option === 'object' && 'guid' in option) {
      return curatedQuestionValue.includes(option.guid);
    }

    if (typeof option === 'object' && 'value' in option) {
      return curatedQuestionValue.includes(option.value);
    }

    return false;
  });

  return hasSameNumberOfOptions && hasSameOptions;
}
